var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-card-container",class:{
      'not-editable':_vm.editSection !== '' && _vm.editSection !== _vm.title,
      'personal-card-container--double': _vm.isDoubleCard
    },attrs:{"data-card-title":_vm.title}},[_vm._t("default",null,null,this.$props)],2)}
var staticRenderFns = []

export { render, staticRenderFns }